module.exports = __webpack_public_path__ + "img/index-section6-friend11.7e61f210.svg";